import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Store from './store';

const styles = require('./index.less');

function AudioList({ store }) {
  store.use();

  const renderAudioItem = (item, index) => {
    return (
      <div className={cx(styles.audioItem, { [styles.isActive]: store.activeIndex === item.index })} onClick={() => store.select(item.index)} key={index}>
        <div className="media-music-layer-14" />
        <div className="media-music-group-8">
          <div className="media-music-layer-13">{item.title}</div>
          {/* <div className="media-music-layer-12">{item.singer}</div> */}
          <div className="media-music-layer-12">{item.singer}</div>

          <div className="media-music-layer-11">{store.formatDuration(item.duration)}</div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.audioList}>
      <div className="media-music-group-6" data-name="歌曲列表">
        <BaseSwiper key={store.audioList.length} store={store.audioListSwiperStore}>
          {Array.from({ length: Math.ceil(store.audioList.length / 6) }).map((_, index) => {
            return (
              <div key={index}>
                {store.audioList
                  .slice(index * 6, (index + 1) * 6)
                  .map((item, index) => <React.Fragment key={index}>{renderAudioItem(item, index)}</React.Fragment>)}
              </div>
            );
          })}
        </BaseSwiper>
      </div>

      <div className={cx('media-music-group-13', styles.paginationSwiper)} data-name="切换按钮">
        {/* 上一页 */}
        <div className="media-music-layer-29" onClick={() => store.prevPage()} />
        {/* 页码 */}
        <BaseSwiper key={store.audioList.length} store={store.paginationSwiperStore}>
          {Array.from({ length: Math.ceil(store.audioList.length / 6) }).map((_, index) => (
            <div
              key={index}
              onClick={() => store.togglePageNum(index)}
              className={cx('media-music-layer-31', styles.paginationItem, { [styles.isActive]: store.currentPageNum === index })}
            />
          ))}
        </BaseSwiper>
        {/* 下一页 */}
        <div className="media-music-layer-30" onClick={() => store.nextPage()} />
      </div>
    </div>
  );
}

export default wrapStore(AudioList, Store);
